// extracted by mini-css-extract-plugin
export default {"container":"tableDataMob_container__8MVHf","UserData":"tableDataMob_UserData__56OZy","restDetails":"tableDataMob_restDetails__MzCfJ","contacts":"tableDataMob_contacts__gScrZ"};